import { useQuery } from 'react-query'
import { useDealership } from '../../../../store/zustand/dealershipStore'
import request from '../../../request'

export const useGetConversionPathsTrackingTags = () => {
  const dealership = useDealership()
  return useQuery(
    ['dealership', dealership?.id, 'performance', 'conversion-paths', 'tracking-tags'],
    () =>
      request({
        url: `/agencies/${dealership?.organization_id}/dealership/${dealership?.id}/performance/conversion-paths/tracking-tags`,
        method: 'GET',
      }).then((res: any) => res.data),
    {
      enabled: !!dealership,
      refetchOnWindowFocus: false,
      refetchInterval: false,
      refetchIntervalInBackground: false,
    },
  )
}
